import React, { useEffect } from "react";
import { animate, motion, useMotionValue } from "framer-motion";
import himaLogo from "@images/partners/hima/HIMA_Logo.jpg";
import dynamoxLogo from "@images/partners/dynamox/Dynamox-Logo.png";
import sciebelLogo from "@images/partners/sciebel/sciebel-bg-logo.webp";
import pwrvoltLogo from "@images/partners/power-volt/POWER-VOLT-nobg-logo.png";
import senyaLogo from "@images/partners/senya/senya-blue-logo.png";
import onisLogo from "@images/partners/onis/onis.svg";
import useMeasure from "react-use-measure";

export const MainPartnersSection: React.FC = () => {
  const partners = [
    { name: "HIMA Smart Safety", logo: himaLogo },
    { name: "Dynamox Solution", logo: dynamoxLogo },
    { name: "Senya Pneumatics", logo: senyaLogo },
    { name: "Sciebel Engineered Products", logo: sciebelLogo },
    { name: "Onis Line Bling", logo: onisLogo },
    { name: "Power Volt Engenharia", logo: pwrvoltLogo },

    { name: "HIMA Smart Safety", logo: himaLogo },
    { name: "Dynamox Solution", logo: dynamoxLogo },
    { name: "Senya Pneumatics", logo: senyaLogo },
    { name: "Sciebel Engineered Products", logo: sciebelLogo },
    { name: "Onis Line Bling", logo: onisLogo },
    { name: "Power Volt Engenharia", logo: pwrvoltLogo },
  ];

  const FAST_DURATION = 25;
  const SLOW_DURATION = 75;

  const [duration, setDuration] = React.useState(FAST_DURATION);

  let [motionRef, { width }] = useMeasure();

  const xTranslation = useMotionValue(0);

  const [mustFinish, setMustFinish] = React.useState(false);
  const [renderer, setRenderer] = React.useState(false);

  useEffect(() => {
    let controls;
    let finalPosition = -width / 2 - 8;

    if (mustFinish) {
      controls = animate(xTranslation, [xTranslation.get(), finalPosition], {
        ease: "linear",
        duration: duration * (1 - xTranslation.get() / finalPosition),
        onComplete: () => {
          setMustFinish(false);
          setRenderer(!renderer);
        },
      });
    } else {
      controls = animate(xTranslation, [0, finalPosition], {
        ease: "linear",
        duration: duration,
        repeat: Infinity,
        repeatType: "loop",
        repeatDelay: 0,
      });
    }

    return controls?.stop;
  }, [xTranslation, width, duration, mustFinish]);

  return (
    <div className="flex flex-col bg-white py-10">
      <h2 className="mb-10 text-center text-3xl font-bold text-gray-800">
        Nossos principais parceiros
      </h2>
      <div className="relative overflow-hidden">
        <motion.div
          className="flex space-x-20"
          ref={motionRef}
          style={{
            x: xTranslation,
            width: "max-content",
            display: "inline-flex",
          }}
          onHoverStart={() => {
            setMustFinish(true);
            setDuration(SLOW_DURATION);
          }}
          onHoverEnd={() => {
            setMustFinish(true);
            setDuration(FAST_DURATION);
          }}
        >
          {[...partners, ...partners].map((partner, index) => (
            <div className="flex-shrink-0" key={index}>
              <img
                src={partner.logo}
                alt={partner.name}
                className="h-14 w-auto object-contain"
              />
            </div>
          ))}
        </motion.div>
      </div>
    </div>
  );
};
